import styled from 'styled-components';
import { Modal as BaseModal } from '../atoms/Modal';

export const Modal = styled(BaseModal)`
  min-width: 804px;
  max-width: 1235px;
  width: 55vw !important;

  .ant-modal-footer button {
    flex: 1;
  }

  .ant-modal-body {
    text-align: left;
  }
`;
